// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"d3964619","213":"9e7bde2b","475":"2ffd9f31","580":"1ec6a1b3","591":"f0938731","747":"9a57d74c"}[chunkId] + ".chunk.js";
};